import React from 'react';
import Hero from './components/research/Hero';
import Main from './components/research/Main';

const Research = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default Research;